import * as React from "react";
import type { SVGProps } from "react";
const SvgDirectionupIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="directionup_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M554.667 316.33 780.5 542.166a42.667 42.667 0 0 0 60.331-60.33L542.464 183.467a43.093 43.093 0 0 0-60.928 0L183.168 481.835a42.667 42.667 0 1 0 60.33 60.33l225.835-225.834v496.981c0 22.101 19.115 40.021 42.667 40.021s42.667-17.92 42.667-40.021V316.331z"
    />
  </svg>
);
export default SvgDirectionupIcon;
